module.exports = __webpack_public_path__ + "static/media/search-not-found.189444e1.png";